import React from 'react';
import { TableCell } from '@material-ui/core';
import classNames from 'classnames';

import Outcome from 'src/components/SportsBetting/EventRow/Outcome/Outcome';

interface OddsCellProps {
  value: number,
  formattedValue: string,
  oddsType: number,
  onClick?: (e) => void, // eslint-disable-line no-unused-vars
  selected?: boolean
  official?: boolean
  quickcharts?: boolean
  blocked?: boolean
}

export default function OddsCell({
  value,
  formattedValue,
  oddsType,
  onClick,
  selected,
  official = false,
  quickcharts = false,
  blocked= false
}: OddsCellProps) {

  return (
    <TableCell
      style={ { width: '60px' } }
      className={
        classNames({
          'competitors-tabel__odds-container': true,
          'competitors-tabel__odds-container--quick-charts': quickcharts

        })
      }
    >
      {
        (value > 0 || formattedValue === 'SP') && oddsType === 3 && (
          <Outcome
            el="div"
            className={
              classNames('competitors-table__market-odds', {
                'competitors-table__market-odds--selected': selected,
                'competitors-table__market-odds': selected,
                'competitors-table__market-odds--blocked': blocked,
                'competitors-table__market-odds--official': official
              })
            }
            onClick={ onClick }
            value={ formattedValue }
            isSuspended={ blocked }
          />
        )
      }
      { // Shows win odds for tote markets.
        value > 0 && oddsType === 2 && (
          <div className="competitors-table__odds-container">
            <span className="competitors-table__main-odds">{ formattedValue }</span>
          </div>
        )
      }
    </TableCell>
  );
}
